export const familyAccessMigrations = [
  {
    id: '014_guardian_qr_challenges',
    sql: `
      CREATE TABLE guardian_qr_challenges (
        id UUID PRIMARY KEY,
        candidate_user_id UUID NOT NULL REFERENCES users(id) ON DELETE CASCADE,
        token_hash TEXT NOT NULL UNIQUE,
        status TEXT NOT NULL DEFAULT 'issued'
          CHECK (status IN ('issued', 'claimed', 'consumed', 'expired')),
        issued_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        expires_at TIMESTAMPTZ NOT NULL,
        claim_hash TEXT UNIQUE,
        claim_expires_at TIMESTAMPTZ,
        claimed_at TIMESTAMPTZ,
        consumed_at TIMESTAMPTZ
      );
      CREATE INDEX guardian_qr_challenges_candidate_idx
        ON guardian_qr_challenges (candidate_user_id, status, issued_at DESC);
    `,
  },
  {
    id: '015_family_representatives',
    sql: `
      ALTER TABLE users DROP CONSTRAINT users_account_type_value;
      ALTER TABLE users ADD CONSTRAINT users_account_type_value
        CHECK (account_type IN ('candidate', 'guardian', 'representative'));
      ALTER TABLE guardian_exceptions ADD COLUMN representative_name TEXT;
      ALTER TABLE guardian_exceptions ADD COLUMN representative_user_id UUID
        REFERENCES users(id) ON DELETE SET NULL;
      UPDATE guardian_exceptions
      SET status='pending', reviewed_by=NULL, reviewed_at=NULL, contact_confirmed_at=NULL
      WHERE status='approved' AND representative_user_id IS NULL;
      ALTER TABLE journey_call_guardians DROP CONSTRAINT journey_call_guardians_verified_source;
      ALTER TABLE journey_call_guardians ADD CONSTRAINT journey_call_guardians_verified_source
        CHECK (
          (selection_mode='guardian' AND guardian_user_id IS NOT NULL
            AND verification_id IS NOT NULL AND exception_id IS NULL)
          OR
          (selection_mode='exception' AND guardian_user_id IS NOT NULL
            AND verification_id IS NULL AND exception_id IS NOT NULL)
        ) NOT VALID;
      CREATE TABLE representative_access_codes (
        id UUID PRIMARY KEY,
        exception_id UUID NOT NULL REFERENCES guardian_exceptions(id) ON DELETE CASCADE,
        candidate_user_id UUID NOT NULL REFERENCES users(id) ON DELETE CASCADE,
        representative_user_id UUID NOT NULL REFERENCES users(id) ON DELETE CASCADE,
        code_hash TEXT NOT NULL UNIQUE,
        status TEXT NOT NULL DEFAULT 'issued'
          CHECK (status IN ('issued', 'consumed', 'expired')),
        issued_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        expires_at TIMESTAMPTZ NOT NULL,
        consumed_at TIMESTAMPTZ
      );
      CREATE INDEX representative_access_codes_candidate_idx
        ON representative_access_codes (candidate_user_id, status, issued_at DESC);
    `,
  },
  {
    id: '016_representative_invitations',
    sql: `
      UPDATE users SET username='member-' || REPLACE(id::text, '-', '')
      WHERE account_type='candidate' AND username IS NULL;
      CREATE TABLE guardian_representative_invitations (
        id UUID PRIMARY KEY,
        exception_id UUID NOT NULL UNIQUE REFERENCES guardian_exceptions(id) ON DELETE CASCADE,
        candidate_user_id UUID NOT NULL REFERENCES users(id) ON DELETE CASCADE,
        representative_user_id UUID NOT NULL REFERENCES users(id) ON DELETE CASCADE,
        status TEXT NOT NULL DEFAULT 'pending'
          CHECK (status IN ('pending', 'accepted', 'rejected', 'revoked')),
        created_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        responded_at TIMESTAMPTZ,
        CHECK (candidate_user_id <> representative_user_id)
      );
      CREATE INDEX guardian_representative_invitations_inbox_idx
        ON guardian_representative_invitations (representative_user_id, status, created_at DESC);
    `,
  },
  {
    id: '017_livekit_call_controls',
    sql: `
      ALTER TABLE meeting_proposals ADD COLUMN call_ended_at TIMESTAMPTZ;
      ALTER TABLE meeting_proposals ADD COLUMN call_ended_by UUID REFERENCES users(id) ON DELETE SET NULL;
      ALTER TABLE meeting_call_sessions ADD COLUMN provider_joined_at TIMESTAMPTZ;
      ALTER TABLE meeting_call_sessions ADD COLUMN forced_reason TEXT;
      CREATE TABLE meeting_call_controls (
        meeting_id UUID PRIMARY KEY REFERENCES meeting_proposals(id) ON DELETE CASCADE,
        solo_identity TEXT,
        solo_since TIMESTAMPTZ,
        updated_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        CHECK ((solo_identity IS NULL) = (solo_since IS NULL))
      );
      CREATE INDEX meeting_call_sessions_provider_idx
        ON meeting_call_sessions (meeting_id, provider_joined_at DESC);
      CREATE TABLE livekit_webhook_events (
        id TEXT PRIMARY KEY,
        event_type TEXT NOT NULL,
        received_at TIMESTAMPTZ NOT NULL DEFAULT NOW()
      );
    `,
  },
  {
    id: '018_profile_preferences_and_photos',
    sql: `
      ALTER TABLE profiles ADD COLUMN religion TEXT;
      ALTER TABLE profiles ADD COLUMN preferred_religion TEXT;
      ALTER TABLE profiles ADD COLUMN preferred_eye_colors TEXT[] NOT NULL DEFAULT ARRAY['any']::TEXT[];
      ALTER TABLE profiles ADD COLUMN preferred_hair_colors TEXT[] NOT NULL DEFAULT ARRAY['any']::TEXT[];
      ALTER TABLE profiles ADD COLUMN identity_status TEXT NOT NULL DEFAULT 'unverified';
      ALTER TABLE profiles ADD COLUMN identity_note TEXT NOT NULL DEFAULT '';
      ALTER TABLE profiles ADD CONSTRAINT profiles_religion_value
        CHECK (religion IN ('muslim','non_muslim'));
      ALTER TABLE profiles ADD CONSTRAINT profiles_preferred_religion_value
        CHECK (preferred_religion IN ('muslim','non_muslim'));
      ALTER TABLE profiles ADD CONSTRAINT profiles_identity_status_value
        CHECK (identity_status IN ('unverified','reviewing','verified'));
      UPDATE profiles SET country=CASE
        WHEN city<>'' AND country<>'' AND city<>country THEN city || '، ' || country
        WHEN country<>'' THEN country ELSE city END,
        city=CASE WHEN country<>'' THEN country ELSE city END;

      CREATE TABLE profile_photos (
        user_id UUID PRIMARY KEY REFERENCES users(id) ON DELETE CASCADE,
        original_data BYTEA NOT NULL,
        original_mime TEXT NOT NULL CHECK (original_mime IN ('image/jpeg','image/webp')),
        blurred_data BYTEA NOT NULL,
        blurred_mime TEXT NOT NULL CHECK (blurred_mime IN ('image/jpeg','image/webp')),
        updated_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        CHECK (octet_length(original_data) <= 1200000),
        CHECK (octet_length(blurred_data) <= 250000)
      );
      CREATE TABLE profile_photo_access (
        owner_user_id UUID NOT NULL REFERENCES users(id) ON DELETE CASCADE,
        viewer_user_id UUID NOT NULL REFERENCES users(id) ON DELETE CASCADE,
        status TEXT NOT NULL CHECK (status IN ('requested','revealed','declined')),
        requested_by UUID NOT NULL REFERENCES users(id) ON DELETE CASCADE,
        created_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        updated_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        PRIMARY KEY (owner_user_id,viewer_user_id),
        CHECK (owner_user_id<>viewer_user_id)
      );
      CREATE INDEX profile_photo_access_viewer_idx
        ON profile_photo_access (viewer_user_id,status,updated_at DESC);
    `,
  },
  {
    id: '019_normalize_combined_residence',
    sql: `
      UPDATE profiles SET country=LEFT(country,LENGTH(country)-LENGTH(city)-2)
      WHERE city<>'' AND country LIKE city || '، %'
        AND RIGHT(country,LENGTH(city)+2)='، ' || city;
    `,
  },
  {
    id: '020_demo_religion_defaults',
    sql: `
      UPDATE profiles p SET religion='muslim',preferred_religion='muslim'
      FROM users u WHERE u.id=p.user_id AND u.email LIKE '%@alatalabak.local'
        AND (p.religion IS NULL OR p.preferred_religion IS NULL);
    `,
  },
  {
    id: '021_demo_readable_usernames',
    sql: `
      UPDATE users SET username='ahmedbinmansour'
      WHERE email='user@alatalabak.local' AND username LIKE 'member-%'
        AND NOT EXISTS (SELECT 1 FROM users taken WHERE taken.username='ahmedbinmansour');
      UPDATE users SET username='maryam'
      WHERE email='partner@alatalabak.local' AND username LIKE 'member-%'
        AND NOT EXISTS (SELECT 1 FROM users taken WHERE taken.username='maryam');
    `,
  },
  {
    id: '022_disallow_married_woman_profiles',
    sql: `
      ALTER TABLE profiles ADD CONSTRAINT profiles_married_woman_forbidden
        CHECK (NOT (gender='woman' AND marital_status='married'));
    `,
  },
  {
    id: '023_profile_music_preferences',
    sql: `
      ALTER TABLE profiles ADD COLUMN music_preferences TEXT[] NOT NULL
        DEFAULT ARRAY['none']::TEXT[];
    `,
  },
  {
    id: '024_guardian_manual_review_and_account_retention',
    sql: `
      ALTER TABLE guardian_invitations ADD COLUMN phone_encrypted TEXT;
      ALTER TABLE guardian_invitations ADD COLUMN phone_last_four TEXT;
      ALTER TABLE guardian_invitations ADD COLUMN admin_note TEXT NOT NULL DEFAULT '';
      ALTER TABLE guardian_invitations ADD COLUMN reviewed_by UUID REFERENCES users(id) ON DELETE SET NULL;
      ALTER TABLE guardian_invitations ADD COLUMN reviewed_at TIMESTAMPTZ;
      ALTER TABLE guardian_invitations ADD COLUMN contact_confirmed_at TIMESTAMPTZ;
      CREATE INDEX guardian_invitations_manual_review_idx
        ON guardian_invitations (status, created_at) WHERE status='registered';

      ALTER TABLE users ADD COLUMN deleted_at TIMESTAMPTZ;
      ALTER TABLE users ADD COLUMN purge_after TIMESTAMPTZ;
      ALTER TABLE users ADD CONSTRAINT users_deletion_schedule_consistent
        CHECK ((deleted_at IS NULL) = (purge_after IS NULL));
      CREATE INDEX users_pending_purge_idx ON users (purge_after) WHERE purge_after IS NOT NULL;
    `,
  },
  {
    id: '025_family_account_credentials_and_share_links',
    sql: `
      ALTER TABLE guardian_representative_invitations
        ALTER COLUMN representative_user_id DROP NOT NULL;
      ALTER TABLE guardian_representative_invitations ADD COLUMN invited_full_name TEXT;
      ALTER TABLE guardian_representative_invitations ADD COLUMN invited_phone_encrypted TEXT;
      ALTER TABLE guardian_representative_invitations ADD COLUMN invited_phone_last_four TEXT;
      ALTER TABLE guardian_representative_invitations ADD COLUMN link_token_hash TEXT;
      ALTER TABLE guardian_representative_invitations ADD COLUMN expires_at TIMESTAMPTZ;
      ALTER TABLE guardian_representative_invitations ADD COLUMN consumed_at TIMESTAMPTZ;
      UPDATE guardian_representative_invitations invitation
      SET invited_full_name=COALESCE(invitation.invited_full_name, family.display_name),
          expires_at=COALESCE(invitation.expires_at, invitation.created_at+INTERVAL '15 minutes')
      FROM users family WHERE family.id=invitation.representative_user_id;
      CREATE UNIQUE INDEX guardian_representative_share_token_idx
        ON guardian_representative_invitations (link_token_hash)
        WHERE link_token_hash IS NOT NULL;
      CREATE INDEX guardian_representative_expiry_idx
        ON guardian_representative_invitations (status, expires_at);
    `,
  },
  {
    id: '026_recoverable_representative_links',
    sql: `
      ALTER TABLE guardian_representative_invitations
        ADD COLUMN link_token_encrypted TEXT;
    `,
  },
  {
    id: '027_repair_inconsistent_family_approvals',
    sql: `
      UPDATE guardian_exceptions exception
      SET status='pending',reviewed_by=NULL,reviewed_at=NULL,contact_confirmed_at=NULL
      WHERE exception.status='approved' AND NOT EXISTS (
        SELECT 1 FROM guardian_representative_invitations invitation
        JOIN users representative ON representative.id=invitation.representative_user_id
        WHERE invitation.exception_id=exception.id AND invitation.status='accepted'
          AND representative.account_type='representative' AND representative.is_active
      );
    `,
  },
  {
    id: '028_family_meeting_schedule_confirmations',
    sql: `
      CREATE TABLE meeting_schedule_confirmations (
        meeting_id UUID NOT NULL REFERENCES meeting_proposals(id) ON DELETE CASCADE,
        user_id UUID NOT NULL REFERENCES users(id) ON DELETE CASCADE,
        confirmed_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        PRIMARY KEY (meeting_id, user_id)
      );
      CREATE INDEX meeting_schedule_confirmations_user_idx
        ON meeting_schedule_confirmations (user_id, confirmed_at DESC);
    `,
  },
  {
    id: '029_seed_account_suppressions',
    sql: `
      CREATE TABLE seed_account_suppressions (
        email TEXT PRIMARY KEY,
        deleted_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        deleted_by UUID REFERENCES users(id) ON DELETE SET NULL
      );
    `,
  },
  {
    id: '030_direct_profile_publishing_and_child_limit',
    sql: `
      ALTER TABLE profiles ADD COLUMN preferred_max_children INTEGER NOT NULL DEFAULT 5;
      ALTER TABLE profiles ADD CONSTRAINT profiles_preferred_max_children_range
        CHECK (preferred_max_children BETWEEN 0 AND 5);
      UPDATE profiles
      SET publication_requested=TRUE,
          approval_status='approved',
          is_published=TRUE,
          reviewed_by=NULL,
          reviewed_at=NULL,
          review_note='',
          preferred_religion=religion,
          preferred_max_children=CASE WHEN accepts_partner_children=FALSE THEN 0 ELSE 5 END
      WHERE is_complete;
    `,
  },
  {
    id: '031_guardian_contact_verification_evidence',
    sql: `
      ALTER TABLE guardian_contact_hashes ADD COLUMN contact_name_encrypted TEXT;
      ALTER TABLE guardian_contact_hashes ADD COLUMN contact_phone_encrypted TEXT;

      CREATE TABLE guardian_contact_matches (
        invitation_id UUID NOT NULL REFERENCES guardian_invitations(id) ON DELETE CASCADE,
        contact_digest TEXT NOT NULL,
        candidate_name_encrypted TEXT NOT NULL,
        candidate_phone_encrypted TEXT NOT NULL,
        guardian_name_encrypted TEXT NOT NULL,
        guardian_phone_encrypted TEXT NOT NULL,
        created_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        PRIMARY KEY (invitation_id, contact_digest)
      );
    `,
  },
  {
    id: '032_guardian_change_history',
    sql: `
      CREATE TABLE guardian_change_history (
        id UUID PRIMARY KEY,
        candidate_user_id UUID REFERENCES users(id) ON DELETE SET NULL,
        candidate_name TEXT NOT NULL,
        candidate_email TEXT,
        candidate_username TEXT,
        former_guardian_user_id UUID NOT NULL,
        former_guardian_name TEXT NOT NULL,
        former_guardian_email TEXT,
        former_guardian_username TEXT,
        former_guardian_phone_encrypted TEXT,
        reason TEXT NOT NULL,
        created_at TIMESTAMPTZ NOT NULL DEFAULT NOW()
      );
      CREATE INDEX guardian_change_history_created_idx
        ON guardian_change_history (created_at DESC);
      CREATE INDEX guardian_change_history_candidate_idx
        ON guardian_change_history (candidate_user_id, created_at DESC);
    `,
  },
  {
    id: '033_relationship_event_timeline',
    sql: `
      CREATE TABLE relationship_events (
        id BIGSERIAL PRIMARY KEY,
        request_id UUID NOT NULL REFERENCES engagement_requests(id) ON DELETE CASCADE,
        journey_id UUID REFERENCES journeys(id) ON DELETE CASCADE,
        actor_user_id UUID REFERENCES users(id) ON DELETE SET NULL,
        event_type TEXT NOT NULL CHECK (event_type IN (
          'request_sent','request_accepted','request_declined','request_withdrawn',
          'photo_requested','photo_approved','photo_declined','photo_shared',
          'meeting_proposed','meeting_confirmed','meeting_cancelled','meeting_completed'
        )),
        details JSONB NOT NULL DEFAULT '{}'::jsonb,
        created_at TIMESTAMPTZ NOT NULL DEFAULT NOW()
      );
      CREATE INDEX relationship_events_request_idx
        ON relationship_events (request_id, created_at, id);
      CREATE INDEX relationship_events_journey_idx
        ON relationship_events (journey_id, created_at, id);

      INSERT INTO relationship_events (request_id,actor_user_id,event_type,created_at)
      SELECT id,sender_user_id,'request_sent',created_at FROM engagement_requests;

      INSERT INTO relationship_events (request_id,journey_id,actor_user_id,event_type,created_at)
      SELECT request.id,journey.id,
        CASE WHEN request.status='withdrawn' THEN request.sender_user_id ELSE request.recipient_user_id END,
        'request_' || request.status,request.updated_at
      FROM engagement_requests request
      LEFT JOIN journeys journey ON journey.request_id=request.id
      WHERE request.status<>'pending';

      INSERT INTO relationship_events (request_id,journey_id,actor_user_id,event_type,details,created_at)
      SELECT request.id,journey.id,access.requested_by,
        CASE WHEN access.status='requested' THEN 'photo_requested'
             WHEN access.status='declined' THEN 'photo_declined'
             WHEN access.requested_by=access.owner_user_id THEN 'photo_shared'
             ELSE 'photo_approved' END,
        jsonb_build_object('ownerUserId',access.owner_user_id,'viewerUserId',access.viewer_user_id),
        access.updated_at
      FROM profile_photo_access access
      JOIN LATERAL (
        SELECT candidate.* FROM engagement_requests candidate
        WHERE candidate.status='accepted' AND (
          (candidate.sender_user_id=access.owner_user_id AND candidate.recipient_user_id=access.viewer_user_id)
          OR (candidate.sender_user_id=access.viewer_user_id AND candidate.recipient_user_id=access.owner_user_id))
        ORDER BY candidate.updated_at DESC LIMIT 1
      ) request ON TRUE
      LEFT JOIN journeys journey ON journey.request_id=request.id;

      INSERT INTO relationship_events (request_id,journey_id,actor_user_id,event_type,details,created_at)
      SELECT journey.request_id,meeting.journey_id,meeting.proposed_by,'meeting_proposed',
        jsonb_build_object('meetingId',meeting.id,'startsAt',meeting.starts_at,'timeZone',meeting.time_zone),
        meeting.created_at
      FROM meeting_proposals meeting JOIN journeys journey ON journey.id=meeting.journey_id;

      INSERT INTO relationship_events (request_id,journey_id,actor_user_id,event_type,details,created_at)
      SELECT journey.request_id,meeting.journey_id,NULL,'meeting_' || meeting.status,
        jsonb_build_object('meetingId',meeting.id,'startsAt',meeting.starts_at,'timeZone',meeting.time_zone),
        meeting.created_at + INTERVAL '1 microsecond'
      FROM meeting_proposals meeting JOIN journeys journey ON journey.id=meeting.journey_id
      WHERE meeting.status<>'proposed';

    `,
  },
  {
    id: '034_remove_introduction_question_fields',
    sql: `
      ALTER TABLE engagement_requests DROP COLUMN IF EXISTS intro_reason;
      ALTER TABLE engagement_requests DROP COLUMN IF EXISTS family_view;
      ALTER TABLE engagement_requests DROP COLUMN IF EXISTS meeting_goal;
      ALTER TABLE engagement_requests DROP COLUMN IF EXISTS message;
    `,
  },
  {
    id: '035_user_notifications_and_call_events',
    sql: `
      CREATE TABLE user_notifications (
        id UUID PRIMARY KEY,
        user_id UUID NOT NULL REFERENCES users(id) ON DELETE CASCADE,
        type TEXT NOT NULL CHECK (type IN (
          'meeting_proposed','meeting_confirmed','meeting_cancelled',
          'schedule_confirmed','call_ready'
        )),
        title TEXT NOT NULL,
        body TEXT NOT NULL,
        request_id UUID REFERENCES engagement_requests(id) ON DELETE CASCADE,
        journey_id UUID REFERENCES journeys(id) ON DELETE CASCADE,
        dedupe_key TEXT NOT NULL,
        read_at TIMESTAMPTZ,
        created_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        UNIQUE (user_id, dedupe_key)
      );
      CREATE INDEX user_notifications_user_idx
        ON user_notifications (user_id, created_at DESC);

      ALTER TABLE relationship_events
        DROP CONSTRAINT relationship_events_event_type_check;
      ALTER TABLE relationship_events
        ADD CONSTRAINT relationship_events_event_type_check CHECK (event_type IN (
          'request_sent','request_accepted','request_declined','request_withdrawn',
          'photo_requested','photo_approved','photo_declined','photo_shared',
          'meeting_proposed','meeting_confirmed','meeting_cancelled','meeting_completed',
          'call_joined','call_left'
        ));
    `,
  },
  {
    id: '036_call_empty_state',
    sql: `
      ALTER TABLE meeting_call_controls ADD COLUMN empty_since TIMESTAMPTZ;
    `,
  },
] as const;
